<template>
  <div class="audioDetail">
    <tip></tip>
    <div class="content" v-if="!enable">
      <h3>{{ObjName}}</h3>
      <p class="name">
        <span>{{UserName}}</span>
      </p>
      <div class="big-img">
        <img :src="audioObj.pic" alt="">
      </div>
      <div class="buylink" v-if="audioObj.buy_link" @click="gotobuy(audioObj.buy_link)">
        <span>{{ audioObj.buy_title || '购买此书' }}</span>
      </div>
      <!-- 音频播放控件 -->
      <div class="p_cotrol">
        <div class="p_slider" >
          <div class="p_slider_track"></div>
          <div class="p_slider_fill" :style="`width: ${sliderTime}%`"></div>
          <div class="p_slider_thumb_box">
            <div class="p_slider_thumb" @touchstart.prevent="handleTouchStart" @touchend.prevent="handelTouchEnd" :style="`left: ${thumbPosition}`">
              {{ lengthFnn(audio.currentTime) }}/{{ lengthFnn(audio.maxTime) }}
            </div>
          </div>
        </div>
      </div>
      <div class="btns">
        <img class="audio-befor" @click="topFn" src="../../assets/img/zuo@3x.png" alt="">
        <span v-if="audio.playing">
          <img class="audio-play" @click="onPause()" src="../../assets/img/audio-stop.png" alt="">
        </span>
        <span v-else>
          <img class="audio-play" @click="onPlay()" src="../../assets/img/audio-play.png" alt="">
        </span>
        <img class="audio-after" @click="nextFn" src="../../assets/img/you@3x.png" alt="">
      </div>
    </div>
    <div v-else class="isData"><empty/></div>
    <!-- 此处的ref属性，可以很方便的在vue组件中通过 this.$refs.audio获取该dom元素 -->
    <audio
      ref="audio"
      @pause="onPause"
      @play="onPlay"
      @timeupdate="handleAudioTimeUpdated"
      @loadedmetadata="onLoadedmetadata"
      :src="audioUrl"
    ></audio>
  </div>
</template>

<script>
import tip from '@/components/tip.vue';
import empty from '@/components/empty.vue'
import {Base64} from 'js-base64';
import { Indicator } from 'mint-ui';
import wechat from "@/plugins/wx";
export default {
  components: {
    tip,
    empty,
  },
  data() {
    return {
      audioObj: {
        name:'',
        user_name: '',
        pic:'',
        enable: true,
      },
      id: 0,
      audioUrl: '',
      isTopFlag: false,
      isNextFlag: false,
      sliderTime: 0, //滑动进度时间
      audio: {
        playing: false, // 该字段是音频是否处于播放状态的属性
        currentTime: 0, // 音频当前播放时长
        maxTime: 0, // 音频最大播放时长
        minTime: 0,
        step: 0.1,
      },
      enable: false,
      istuodong: false,
      shareConfig: {
        title: '分享标题',
        desc: '这是一个测试的微信分享',
        link: 'https://example.com', // 分享链接
        imgUrl: 'https://example.com/image.jpg', // 分享图标
      },

    }
  },
  computed: {
    ObjName:function (){
      return this.audioObj.name.slice(0,18);
    },
    UserName:function (){
      return this.audioObj.user_name.slice(0,10);
    },
    // 计算滑块实际位置，以左边距离为准
    thumbPosition: function() {
      // 滑块宽度
      const thumbWidthRatio = 160 / 530; // 滑块宽度占进度条宽度的比例
      
      // 0%时滑块完全在左侧（左边缘对齐进度条左边缘）
      if (this.sliderTime <= 0) return "0";
      
      // 100%时滑块完全在右侧（右边缘对齐进度条右边缘）
      if (this.sliderTime >= 100) return `calc(100% - ${thumbWidthRatio * 100}%)`;
      
      // 计算可移动的最大距离（进度条宽度减去滑块宽度）
      const maxMoveDistance = 1 - thumbWidthRatio;
      
      // 根据进度百分比计算位置
      const position = (this.sliderTime / 100) * maxMoveDistance * 100;
      console.log("位置", position, this.sliderTime);
      return `${position}%`;
    }
  },
  created () {
    this.id = this.$route.query.id || '519542de-455e-4f03-bde8-9fd37a32bc67'
    this.getaudioList()
    this.report(this.id,2)
  },
  methods: {
    gotobuy(url){
      window.open(url);
    },
    // 控制音频的播放与暂停
    playaudio() {
      console.log("控制音频的播放与暂停");
      return this.audio.playing ? this.pause() : this.play();
    },
    async report(id,dt) {
      try {
        // 发送点击事件请求到服务端
        await this.$report.sendReport({
          "id": id,
          "dt":dt
        });

      } catch (error) {
        console.error("Error sending click request:", error);
      }
    },
    // 播放音频
    play() {
      this.$refs.audio.play();
      console.log("音频播放222");
    },
    // 暂停音频
    pause() {
      this.$refs.audio.pause();
      console.log("暂停音频");
    },
    // 音频播放
    onPlay() {
      this.play()
      this.audio.playing = true;
      console.log("音频播放");
    },
    // 当音频暂停
    onPause() {
      this.pause()
      this.audio.playing = false;
    },
    // 当指定的音频/视频的元数据已加载时，会发生 loadedmetadata 事件。
    onLoadedmetadata(res) {
      console.log("loadedmetadata数据已加载时");
      this.audio.maxTime = parseInt(res.target.duration);
      if(this.audio.playing){
        this.onPlay()
      }
    },
    // 当音频当前时间改变后，进度条也要改变
    handleAudioTimeUpdated(res) {
      console.log("timeupdate",res.target.currentTime,this.audio.maxTime);
      this.audio.currentTime = res.target.currentTime;
      if(!this.istuodong){
        this.sliderTime = parseInt(
          (this.audio.currentTime / this.audio.maxTime) * 100
        )
        if(this.sliderTime>100){
          this.sliderTime=100
        }
      }
      // if(this.audio.currentTime >= this.audio.maxTime){
      //   this.audio.currentTime = 0
      //   this.sliderTime = parseInt(
      //     (this.audio.currentTime / this.audio.maxTime) * 100
      //   )
      // }
    },
    // touchstart	触摸开始，多点触控，后面的手指同样会触发
    // touchmove	接触点改变，滑动时
    // touchend	触摸结束，手指离开屏幕时
    // touchcancel	触摸被取消，当系统停止跟踪触摸的时候触发
    handelTouchEnd(e){
      e.preventDefault(); // 防止默认行为
      e.stopPropagation(); // 阻止事件冒泡
      
      // 确保有触摸点
      if (e.changedTouches && e.changedTouches.length > 0) {
        this.setValue(e.changedTouches[0], true);
      }
      
      document.removeEventListener("touchmove", this.handleTouchMove, { passive: false });
      this.istuodong = false;
    },
    // 拖动开始
    handleTouchStart(e) {
      e.preventDefault(); // 防止默认行为
      e.stopPropagation(); // 阻止事件冒泡
      this.istuodong = true;
      
      // 记录初始触摸位置，但不立即更新滑块位置
      // 这样可以避免手指刚触摸屏幕时滑块就跳跃的问题
      
      document.addEventListener("touchmove", this.handleTouchMove, { passive: false });
    },
    // 移动的使用更新位置，不是更新音频播放
    handleTouchMove(e) {
      e.preventDefault(); // 防止页面滚动
      e.stopPropagation(); // 阻止事件冒泡
      
      // 确保有触摸点
      if (e.changedTouches && e.changedTouches.length > 0) {
        this.setValue(e.changedTouches[0]);
      }
    },
    // 从点击位置更新 value
    setValue(e, flag = false) {
      const $el = this.$el.querySelector('.p_slider'); // 获取进度条元素
      const rect = $el.getBoundingClientRect();
      const { maxTime, minTime, step } = this.audio;
      
      // 获取触摸位置的x坐标
      const clientX = e.clientX || (e.touches && e.touches[0] ? e.touches[0].clientX : 
                                    (e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : 0));
      
      // 计算滑块宽度
      const thumbWidth = window.innerWidth * (160 / 750);
      
      // 获取点击位置相对于进度条的位置
      let posX = clientX - rect.left;
      console.log("posX",posX);
      
      // 调整触摸位置，让滑块以中心点为基准
      // 减去滑块宽度的一半，这样触摸点对应滑块中心
      posX = posX - (thumbWidth / 2);
      
      // 计算可用宽度（考虑滑块宽度）
      const usableWidth = rect.width - thumbWidth;
      
      // 限制在有效范围内
      if (posX < 0) posX = 0;
      if (posX > usableWidth) {
        // 如果超出可用宽度，设为最大值
        this.sliderTime = 100;
        this.audio.currentTime = this.audio.maxTime;
        
        if(flag) {
          this.$refs.audio.currentTime = this.audio.maxTime;
        }
        return;
      }
      
      // 根据可用宽度计算百分比位置
      const percentPosition = posX / usableWidth;
      
      // 计算对应的音频时间
      let value = percentPosition * (maxTime - minTime) + minTime;
      value = Math.round(value / step) * step;
      value = parseFloat(value.toFixed(5));
      
      // 限制在有效范围内
      if (value > maxTime) {
        value = maxTime;
      } else if (value < minTime) {
        value = minTime;
      }
      
      // 计算进度百分比
      let percentage = (value / this.audio.maxTime) * 100;
      if (percentage < 0) percentage = 0;
      if (percentage > 100) percentage = 100;
      
      this.sliderTime = parseInt(percentage);
      
      // 更新音频当前时间
      this.audio.currentTime = value;
      
      if(flag){
        this.$refs.audio.currentTime = value;
      }
    },
    // 拖动进度条，改变当前时间，index是进度条改变时的回调函数的参数0-100之间，需要换算成实际时间
    changeCurrentTime(index) {
      this.$refs.audio.currentTime = parseInt(
        (index / 100) * this.audio.maxTime
      );
    },
    topFn(){
      const audio = this.$refs.audio;
      if (audio && !isNaN(audio.duration)) {
        const newTime = audio.currentTime - 15;
        audio.currentTime = Math.max(newTime, 0); // 防止负数
      }
      // if(this.audioObj.previous_audio_id){
      //   this.id = this.audioObj.previous_audio_id
      //   this.getaudioList()
      // }
    },
    nextFn(){
      const audio = this.$refs.audio;
      if (audio && !isNaN(audio.duration)) {
        const newTime = audio.currentTime + 15;
        audio.currentTime = Math.min(newTime, audio.duration);
      }
      // if(this.audioObj.next_audio_id){
      //   this.id = this.audioObj.next_audio_id
      //   this.getaudioList()
      // }
    },
    lengthFnn(duration) {
      let tTime = duration;
      let m = Math.floor(tTime%3600/60);
      let s = Math.floor(tTime%60);
      m = m>=10?m:"0"+m
      s = s>=10?s:"0"+s
      return m+":"+s
    },
    async getaudioList() {
      try {
        Indicator.open()
        //const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/v1/audio/${this.id}`)

        //this.audioObj = res.data.data
        const currentUrl = window.location.href.split('#')[0];

        const res2 = await this.axios.get(`https://api.ayerdudu.com/v1/audio/${this.id}`)
        //const res2 = await this.axios.get(`http://localhost:8080/v1/audio/${this.id}`)
        const albumInfo = res2.data.data
        this.audioObj = res2.data.data
        // this.audioObj.name = albumInfo.name
        // this.audioObj.user_name = albumInfo.user_name
        // this.audioObj.pic = albumInfo.pic
        //this.audioObj = JSON.parse(JSON.stringify( res2.data.data))
        this.shareConfig.title = albumInfo.name;
        this.shareConfig.desc = albumInfo.description;
        this.shareConfig.link = currentUrl;
        this.shareConfig.imgUrl = albumInfo.pic;
        //console.log("分享配置", this.shareConfig);
        //const currentUrl = 'http://videos.ayerdudu.com/audioDetail?id=d1b469a1-91f4-1400-d29e-241571036c3c';
        wechat.initConfig(currentUrl).then(() => {
          // 配置分享内容
          wechat.setShareOptions(this.shareConfig);
        });
        this.enable = res2.data.data.enable
        if(this.audioObj.previous_audio_id){
          this.isTopFlag = false
        }else{
          this.isTopFlag = true
        }
        if(this.audioObj.next_audio_id){
          this.isNextFlag = false
        }else{
          this.isNextFlag = true
        }
        this.getAuditMp3(res2.data.data.url)
        Indicator.close()
      } catch (err) {
        console.log(err)
        Indicator.close()
      }
    },
    // 获取单个音频，页面初始化，如果之前是播放中，那继续播放
    async getAuditMp3(id){
      try {
        const url = Base64.encode(id)
        const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/v1/storage/qiniu/audio/${url}`)
        this.audioUrl = res.data.data
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.audioDetail{
  width: 100%;
  height: 100%;
  min-height: 1300px;
  background: #fff;
  //overflow: hidden;
}
.content{
  h3{
    font-size: 38px;
    font-weight: bold;
    text-align: center;
    line-height: 38px;
    margin-top:46px;
    color: #000;
  }
  .name{
    font-size: 26px;
    text-align: center;
    margin: 24px auto 0;

    >span{
      display: inline-block;
      position: relative;
      line-height: 29px;
      color: #202020;

    }
    >span::before{
      display: block;
      content: '';
      width: 35px;
      background: #cccccc;
      height: 1px;
      position: absolute;
      top: 14px;
      left: -48px;

    }
    >span::after{
      display: block;
      content: '';
      width: 35px;
      background: #cccccc;
      height: 1px;
      position: absolute;
      top: 14px;
      right: -48px;

    }

  }
  .big-img{
    width: 372px;
    height: 372px;
    margin:70px auto 0;
    border-radius: 20px;
    overflow: hidden;
    border: 1px solid #eee;
    img{
      border-radius: 20px;
      width: 100%;
      height: 100%;
    }
  }
}

.btns{
  margin: calc(175 / 750 * 100vw) 0 calc(30 / 750 * 100vw);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .audio-befor{
    width: calc(55 / 750 * 100vw);
    height: calc(41 / 750 * 100vw);
    position: absolute;
    left: calc((750 - 438) / 2 / 750 * 100vw); /* 按照设计稿左边距110px计算 */
  }
  .audio-after{
    width: calc(55/ 750 * 100vw);
    height: calc(41/ 750 * 100vw);
    position: absolute;
    right: calc((750 - 438) / 2 / 750 * 100vw); /* 按照设计稿右边距110px计算 */
  }
  .audio-play{
    width: calc(54 / 750 * 100vw);
    height: calc(66 / 750 * 100vw);
    margin: 0 calc(180 / 750 * 100vw); /* 确保居中且与左右按钮有适当间距 */
  }
}

.huise, .huise2{
  opacity: 0.5;
}
.p_cotrol {
  box-sizing: border-box;
  height: calc(80 / 750 * 100vw);
  width: 100%;
  margin-top: calc(85 / 750 * 100vw);
  position: relative;
  padding: 0;
  background-color: #fff;
  .p_img {
    width: calc(30 / 750 * 100vw);
    height: calc(30 / 750 * 100vw);
  }
  .div_time{
    height: calc(30 / 750 * 100vw);
    margin-bottom: calc(16 / 750 * 100vw);
    .p_time {
      line-height: calc(30 / 750 * 100vw);
      margin: 0 calc(10 / 750 * 100vw);
      color: #888888;
      font-size: calc(24 / 750 * 100vw);
    }
    .p_time_left{
      float: left;
    }
    .p_time_right{
      float: right;
    }
  }
  // 进度条
  .p_slider {
    box-sizing: border-box;
    position: relative;
    height: calc(50 / 750 * 100vw);
    display: flex;
    align-items: center;
    cursor: default;
    user-select: none;
    outline: none;
    width: calc(530 / 750 * 100vw); /* 设计稿宽度 */
    margin: 0 auto; /* 居中显示 */
    padding: 0; /* 移除内边距 */
  }

  .p_slider_track {
    position: absolute;
    height: calc(2 / 750 * 100vw);
    left: 0;
    right: 0;
    top: 50%;
    margin-top: calc(-1 / 750 * 100vw);
    background: #e6e6e6;
  }

  .p_slider_fill {
    position: absolute;
    height: calc(2 / 750 * 100vw);
    width: 100%;
    background: #f6451b;
    left: 0;
    top: 50%;
    margin-top: calc(-1 / 750 * 100vw);
  }

  .p_slider_thumb_box{
    position: absolute;
    height: calc(2 / 750 * 100vw);
    width: 100%; /* 使用100%宽度 */
    left: 0;
    top: 50%;
    margin-top: calc(-1 / 750 * 100vw);
  }
  .p_slider_thumb {
    position: absolute;
    top: 50%;
    width: calc(160 / 750 * 100vw);
    height: calc(38 / 750 * 100vw);
    background: #f6451b;
    color: #ffffff;
    font-size: calc(25 / 750 * 100vw);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: calc(30 / 750 * 100vw);
    transform: translateY(-50%);
    cursor: pointer;
    left: 0; /* 初始位置为0，由sliderTime控制 */
  }
}
.isData{
  line-height: 150px;
  text-align: center;
  font-size: 30px;
}
.buylink{
  display: flex;
  justify-content: center;
  place-items: center;
  align-items: center;
  height: 64px;
  font-size: 24px;
  border: 2px solid #f6451b;
  color: #f6451b;
  border-radius: 40px;
  width: 172px;
  margin:32px auto;

}
</style>
